import { observer } from 'mobx-react-lite';
import React from 'react';
import { Box, Flex } from '@cad-arc';
import { Tooltip } from '../../../common/components/tooltip';
import { HospitalQueueRowData } from '../../../socket/stream-types';
import { BaseQueueCell } from '../../../queues/components/base-queue-cell';

export const HospitalQueueLocationCell = observer(function HospitalQueueLocationCell({
    data,
}: {
    data: HospitalQueueRowData;
}): React.ReactElement {
    return (
        <BaseQueueCell onContextMenu={() => {}}>
            <Flex justify="space-between">
                <Tooltip overlay={data.locationTip}>
                    <Box
                        as="span"
                        whiteSpace="nowrap"
                        overflow="hidden"
                        textOverflow="ellipsis"
                        minWidth={0}
                    >
                        {data.location}
                    </Box>
                </Tooltip>
            </Flex>
        </BaseQueueCell>
    );
});
